import { queryOptions } from '@tanstack/react-query';

import { keys } from '@/lib/query-keys';
import type { PortalSummary, PortalTransaction } from '../schemas/portal';
import {
  PORTAL_SUMMARY_FIXTURE,
  PORTAL_TRANSACTIONS_FIXTURE,
} from './portal-fixtures';

/*
 * Portal consumption layer (mock-first first pass — see ADR 0009).
 *
 * THE MOCK DATA BOUNDARY. There is no portal path in openapi.json and no
 * `lib/api/domains/portal.ts` (adding one against a non-existent endpoint is
 * out of scope), so each queryFn resolves a typed fixture directly — no fetch,
 * no network door. This is the ONE-FILE repoint seam: when the BFF grows the
 * portal endpoints and openapi.json carries them, add `lib/api/domains/portal.ts`
 * and swap each queryFn body to `api.portal.summary()` / `.transactions()`.
 * Short stale time matches the financial-data convention (invoice-queries.ts).
 */

export function portalSummaryQuery() {
  return queryOptions<PortalSummary>({
    queryKey: keys.portal.summary(),
    queryFn: async () => PORTAL_SUMMARY_FIXTURE,
    staleTime: 15_000,
  });
}

export function portalTransactionsQuery() {
  return queryOptions<PortalTransaction[]>({
    queryKey: keys.portal.transactions(),
    queryFn: async () => PORTAL_TRANSACTIONS_FIXTURE,
    staleTime: 15_000,
  });
}
